import { type AuthenticatedUser } from '../../models/User'

const ZOCKS_EMAIL_SUFFIX = '@zocks.io'

export const shouldEnableHotjarForUser = (user: AuthenticatedUser | null | undefined): user is AuthenticatedUser => {
  if (!user) {
    return false
  }
  if (user.isGhosted) {
    return false
  }
  const email = user.email?.toLowerCase() ?? null
  if (!email || email.endsWith(ZOCKS_EMAIL_SUFFIX)) {
    return false
  }
  return true
}
export const ensureHotjarInitialized = (hjid: number) => {
  const w = window as unknown as {
    hj?: unknown
    _hjSettings?: { hjid: number; hjsv: number }
    __hotjarInitialized?: boolean
    __hotjarSiteId?: number
  }

  if (w.__hotjarInitialized || w.hj || document.querySelector('script[data-hotjar-script="true"]')) {
    return
  }
  ;(w as unknown as { hj: (...args: unknown[]) => void }).hj = function (...args: unknown[]) {
    const fn = (w as unknown as { hj: { q?: unknown[][] } }).hj
    fn.q = fn.q || []
    fn.q.push(args)
  }

  w._hjSettings = { hjid, hjsv: 6 }

  const script = document.createElement('script')
  script.async = true
  script.src = `https://static.hotjar.com/c/hotjar-${hjid}.js?sv=${w._hjSettings.hjsv}`
  script.dataset.hotjarScript = 'true'
  document.head.appendChild(script)

  w.__hotjarInitialized = true
  w.__hotjarSiteId = hjid
}
export const setupHotjarUserAttributes = (userId: string, accountId: string) => {
  const w = window as unknown as { hj?: (...args: unknown[]) => void }
  if (typeof w.hj === 'function') {
    w.hj('identify', userId, { account_id: accountId })
  }
}
